import { MessageCircle } from "lucide-react";

const WA_LINK = "https://wa.me/5491165162564?text=Hola%2C%20quiero%20hacer%20una%20consulta%20contable.";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Consultar por WhatsApp"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-40 w-14 h-14 bg-whatsapp rounded-full flex items-center justify-center shadow-lg shadow-whatsapp/30 hover:scale-110 hover:shadow-xl hover:shadow-whatsapp/40 transition-all duration-300 group"
    >
      <MessageCircle className="w-7 h-7 text-white group-hover:scale-110 transition-transform" />
      
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-whatsapp/40 animate-ping opacity-75" style={{ animationDuration: '2s' }} />
    </a>
  );
};
